import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute } from '@angular/router';
import { EntryClassesService } from '../services/entry-classes.service';

interface Entry {
  entry: number,
  horseName: string,
  idPropietario: number,
  id_binomio: number,
  id_caballo: number,
  id_entrenador: number,
  id_jinete: number,
  owner: string,
  riderName: string,
  show: string,
  trainerName: string
}

@Component({
  selector: 'app-entry',
  templateUrl: './entry.component.html',
  styleUrls: ['./entry.component.scss']
})
export class EntryComponent implements OnInit {
  public showId: string;
  public entry: string;
  public entryInfo: Entry = {
    entry: 0,
    horseName: '',
    idPropietario: 0,
    id_binomio: 0,
    id_caballo: 0,
    id_entrenador: 0,
    id_jinete: 0,
    owner: '',
    riderName: '',
    show: '',
    trainerName: ''
  };
  public classes: Array<any> = [];
  public rider: string;
  public isUS: boolean;
  constructor(private db: AngularFirestore, private route: ActivatedRoute, private entryClassesService: EntryClassesService,) {
    this.showId = this.route.snapshot.paramMap.get('showId');
    this.entry = this.route.snapshot.paramMap.get('entryId');
  }

  ngOnInit(): void {
    this.isUS = this.showId.includes('us_');
    if(this.showId) {
      this.getEntryInfo();
    }
  }

  private getEntryInfo() {
    // Convertir entry a número para la consulta
    const entryNumber = parseInt(this.entry);
    this.db.collection('masterLists', ref => ref.where('show','==',this.showId).where('entry','==',entryNumber))
      .valueChanges().subscribe(
        entries => {
          if (entries && entries.length > 0) {
            this.entryInfo = entries[0] as Entry;
            console.log('masterList',this.entryInfo)
            // Una vez que tenemos la info del entry, ejecutamos getEntryClasses
            this.getEntryClasses();
          } else {
            console.log('No entries found for showId:', this.showId, 'entry:', entryNumber);
          }
        }
      );
  }

  private getEntryClasses() {
    console.log('Getting Classes');
    this.entryClassesService.getEntryClasses(this.entry, this.showId).subscribe(
      response => {
        this.classes = response.classes;
        console.log('Response Classes: ', this.classes);
      }
    );
  }
}
